<template>
  <PropertySection
    title="POS+との連携"
    :button="posSavedAuthKey ? '認証キー登録済み' : '認証キー登録'"
    :hideButton="!!posSyncStatus"
    :disabled="posSavedAuthKey"
    small
    @click="posKeyRegisterModal = true"
  >
    <template #text>
      <div :class="['label', { synced: posSyncStatus }]" :key="posSyncStatus">
        {{ posSyncStatus ? '連携中' : '未連携' }}
      </div>
    </template>
    <template #descSlot>
      <div class="desc">
        <template v-if="posSyncStatus">
          連携停止を行うにはPOS+管理画面にて停止の操作を行ってください。<br />
          <a href="#" @click.prevent.stop="posKeyReset">認証キー初期化</a>
        </template>
        <template v-else>
          POS+と連携を行うには、任意の認証キーを登録し、登録した認証キーをPOS+管理画面に登録し連携を進めてください。
          <template v-if="posSavedAuthKey">
            <br /><a href="#" @click.prevent.stop="posKeyReset">認証キー初期化</a>
          </template>
        </template>
      </div>
    </template>
    <PosKeyRegisterModal v-if="posKeyRegisterModal" @close="posKeyRegisterModal = false" @register="posKeyRegister" />
  </PropertySection>
</template>

<script>
import PropertySection from '@/components/molecules/PropertySection'
import Dialog from '@/components/molecules/ModalDialog'
import PosKeyRegisterModal from '@/components/organisms/PosKeyRegisterModal'

export default {
  name: 'PosSync',
  components: {
    PropertySection,
    PosKeyRegisterModal,
  },
  props: {
    posSyncStatus: { type: Number, required: true },
    posSavedAuthKey: { type: Boolean, required: true },
  },
  data() {
    return {
      posKeyRegisterModal: false,
    }
  },
  computed: {},
  methods: {
    async posKeyRegister({ newPassword, confirmPassword }) {
      this.posKeyRegisterModal = false
      if (
        await this.$store.dispatch('stores/password/regist', {
          newPassword,
          confirmPassword,
        })
      ) {
        location.reload()
      }
    },
    async posKeyReset() {
      if (
        (await Dialog.confirm({
          title: '認証キー初期化',
          message:
            'POS+との連携用の認証キーを未設定状態にします。\n認証キーを初期化すると\n認証キーの再登録と連携の再設定が必要になります。',
          cancelText: '戻る',
          okText: '初期化',
        })) &&
        (await this.$store.dispatch('stores/password/clear'))
      ) {
        location.reload()
      }
    },
  },
}
</script>
